import { LocationUtils } from '@ctct/rise-utils';
import { useTranslations } from 'next-intl';
import { type ComponentProps, useMemo } from 'react';

import { type InputOpts } from '../../../types';
import { DropdownInput } from '../../inputs-core';

const StateNameDropdown = ({
  formKey,
  registerOpts,
  ...selectProps
}: InputOpts & ComponentProps<typeof DropdownInput>) => {
  const t = useTranslations('UiForm');
  const emptyValue = useMemo(() => ({ label: t('shared.state.placeholder'), value: '-' }), [t]);
  const dropdownItems = LocationUtils.states.map((state) => ({
    label: state.name,
    value: state.name,
  }));

  return (
    <DropdownInput
      formKey={formKey}
      registerOpts={registerOpts}
      placeholder={t('shared.state.placeholder')}
      items={dropdownItems}
      emptyValue={emptyValue}
      {...selectProps}
    />
  );
};

export { StateNameDropdown };
